import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import SelectField from "components/Select";
import { PrimaryButton } from "components/Buttons";
import { ErrorToaster, SuccessToaster } from "components/Toaster";
import Colors from "assets/Style/Colors";
import { FontFamily } from "assets";
import InputField from "components/Input";
import DatePicker from "components/DatePicker";
import VehicleBookingServices from "services/VehicleBooking";
import UserServices from "services/User";
import { numberRegex } from "utils";

function UpdateSalesInfo() {
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(false);
 
  const [saleDate, setSaleDate] = useState();
  const [staff, setStaff] = useState([]);
  const [detailData, setDetailData] = useState();

  const [selectedBookingCustomer, setSelectedBookingCustomer] = useState(null);

  const [soldPrice, setSoldPrice] = useState(0);
  const [soldPriceAED, setSoldPriceAED] = useState(0);

  const handleSoldPriceChange = (e) => {
    const value = e.target.value;
    setSoldPrice(value);
  };

  useEffect(() => {
    setSoldPriceAED(soldPrice * 3.675);
  }, [soldPrice]);

  const getUsers = async (page, limit, search) => {
    try {
      const params = { page: 1, limit: 100, search };
      const { data } = await UserServices.getUsers(params);
      const rows = data?.users?.rows ?? [];

      const staffOnly = rows.filter(user => user?.user_type_id === 'S');

      const staffData = staffOnly.map(user => ({
        id: user?.id,
        name: user?.name,
      }));

      setStaff(staffData);

    } catch (error) {
      ErrorToaster(error)
    }
  }

  const handleSaleDate = (newDate) => {
    try {
      if (newDate == "Invalid Date") {
        setSaleDate("invalid");
        return;
      }
      setSaleDate(newDate ? new Date(newDate) : newDate);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const updateVehicleBooking = async (formData) => {
    if (!saleDate ) {
      ErrorToaster("Please ensure that Sale Date are selected.");
      return;
    }

    setLoading(true);
    try {
      const obj = {
         booking_id: parseInt(id),
         remarksData: {
          remarksDate: saleDate,
          sale_agent_id: selectedBookingCustomer?.id,
          soldPriceUSD: soldPrice,
          soldPriceAED: parseFloat(soldPriceAED).toFixed(2),
          remarks: formData.remarks,
         },
      };

      const { message } = await VehicleBookingServices.updateVehicleBooking(obj);

      SuccessToaster(message);
      navigate("/vehicle-booking-list");

    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoading(false);
    }
  };

  const getVehicleBookingDetail = async () => {
    try {
      let params = { booking_id: id };
      params.shipping_details = "true";
      const { data } = await VehicleBookingServices.getVehicleBookingDetail(params);
      const { details } = data;
      setDetailData(details);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  useEffect(() => {
    getUsers();
    getVehicleBookingDetail();
  }, []);

  useEffect(() => {
    if (!detailData) return;
    handleSaleDate(detailData?.sale_date);
    setValue("saleDate", detailData?.sale_date);
    setSelectedBookingCustomer({
      id: detailData?.sale_agent_details?.id,
      name: detailData?.sale_agent_details?.name
    });

    setValue("saleAgent", {
      id: detailData?.sale_agent_details?.id,
      name: detailData?.sale_agent_details?.name
    });

    setSoldPrice(detailData?.sold_price);
    setSoldPriceAED(detailData?.sold_price * 3.675);
    setValue("remarks", detailData?.remarks);
  }, [detailData]);

  return (
    <Box sx={{ m: 4, p: 5 }}>
      <Box component="form" onSubmit={handleSubmit(updateVehicleBooking)}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} mb={4}>
            <Typography variant="h5" sx={{ color: Colors.charcoalGrey, fontFamily: FontFamily.NunitoRegular }}>
              Update Sales Info
            </Typography>
          </Grid>

          <Grid item xs={12} sm={4}>
            <DatePicker
              label={"Sale Date*"}
              value={saleDate}
              onChange={handleSaleDate}
              error={errors?.saleDate?.message}
              register={register("saleDate", {
                //  required: "Please select Sale Date." 
                })}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <SelectField
              size={"small"}
              onSearch={(v) => getUsers(v)}
              label={"Sale Agent*"}
              options={staff}
              selected={selectedBookingCustomer}
              onSelect={(value) => setSelectedBookingCustomer(value)}
              error={errors?.saleAgent?.message}
              register={register("saleAgent", { required: "Please select Sale Agent." })}
            />
          </Grid>

         <Grid item xs={12} sm={4}>
             <InputField
                size='small'
                type='number'
                label={"Sold Price $"}
                placeholder={"Enter Price"}
                value={soldPrice}
                register={register("soldPrice", {
                  pattern: numberRegex,
                  onChange: (e) => {
                    handleSoldPriceChange(e);
                  },
                })}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <InputField
                disabled={true}
                label={"Sold Price (AED)"}
                placeholder={"Enter Price"}
                value={parseFloat(soldPriceAED).toFixed(2)}
                register={register("soldPriceAED")}
              />
            </Grid>
            <Grid item xs={12} sm={8}>
              <InputField
                label={"Remarks"}
                placeholder={"Remarks"}
                register={register("remarks")}
              />
            </Grid>
          <Grid item xs={12} sm={12} sx={{ mt: 2, textAlign: "right" }}>
            <PrimaryButton
              title="Update"
              type="submit" 
              loading={loader}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default UpdateSalesInfo;
